module.exports = __webpack_public_path__ + "img/show-block.08451c81.svg";